import { Icon, Typography, type IconKind } from "@saviynt/design-system";
import { ReactNode } from "react";
import { theme } from "../constants/theme";
import { useTheme } from "@repo/mfe-core";

interface FormSectionProps {
  icon?: IconKind;
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  isLast?: boolean;
}

export function FormSection({
  icon,
  title,
  subtitle,
  children,
  className = "",
  isLast = false,
}: FormSectionProps) {
  const { theme: currentTheme } = useTheme();
  return (
    <div
      style={{
        borderColor: !isLast
          ? "var(--color-border-neutral-subtlest, #4a4c59)"
          : undefined,
      }}
      className={`${!isLast ? "border-b" : ""} ${className}`}
    >
      {(icon || title) && (
        <div className="flex gap-2 items-start pt-4 px-6">
          {icon && (
            <Icon
              kind={icon}
              size="medium"
              color="--color-foreground-neutral-subtle"
              dataTheme={currentTheme}
            />
          )}
          {title && (
            <div className="flex-1 flex flex-col gap-0.5">
              <Typography
                kind="h2"
                className={theme.typography.h2}
                color="--color-foreground-neutral-bold"
              >
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  kind="body1"
                  className={theme.typography.body1}
                  color="--color-foreground-neutral-subtle"
                >
                  {subtitle}
                </Typography>
              )}
            </div>
          )}
        </div>
      )}
      <div
        className={`flex flex-col ${theme.spacing.sectionGap} ${theme.spacing.sectionPadding}`}
      >
        {children}
      </div>
    </div>
  );
}
